import React from 'react';
import { Box, Text } from 'ink';
import type { SkillConflictView } from './types';
import { useTheme } from './lib/theme';

interface SkillConflictsMessageProps {
  conflicts: SkillConflictView[];
}

export const SkillConflictsMessage: React.FC<SkillConflictsMessageProps> = ({ conflicts }) => {
  const { tokens } = useTheme();
  return (
    <Box flexDirection="column" paddingLeft={2}>
      <Text color={tokens.text.warning}>[Skill conflicts]</Text>
      {conflicts.map((conflict) => (
        <Box key={conflict.skillName} flexDirection="column" paddingLeft={2}>
          <Text bold>&quot;{conflict.skillName}&quot; collision:</Text>
          <Box paddingLeft={2}>
            <Text color={tokens.text.success}>✓ </Text>
            <Text>{conflict.winner.path} </Text>
            <Text dimColor>({conflict.winner.sourceLabel})</Text>
          </Box>
          {conflict.losers.map((loser) => (
            <Box key={loser.path} paddingLeft={2}>
              <Text color={tokens.text.danger}>✗ </Text>
              <Text>{loser.path} </Text>
              <Text dimColor>({loser.sourceLabel}, skipped)</Text>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};
